import { render, staticRenderFns } from "./ChangePricesByCSVView.vue?vue&type=template&id=2706e300&"
import script from "./ChangePricesByCSVView.vue?vue&type=script&lang=js&"
export * from "./ChangePricesByCSVView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports